import { useRef } from "react"

import Style from "./style"

import ContactInput from "widget/ContactInput"

import usePutAccountContact from "entity/account/usePutAccountContact"

import DefaultSlideModal from "shared/ui/DefaultSlideModal"
import DefaultButton from "shared/ui/DefaultButton"

const ContactModal = ({ international, contact, closeEvent }) => {
    const countryCodeRef = useRef()
    const contactRef = useRef()

    const [putContact] = usePutAccountContact()

    return (
        <DefaultSlideModal title="연락처 수정" closeEvent={closeEvent}>
            <Style.Content>
                <ContactInput countryCode={international} countryCodeRef={countryCodeRef} contact={contact} contactRef={contactRef} />
            </Style.Content>
            <DefaultButton clickEvent={putContact}>수정하기</DefaultButton>
        </DefaultSlideModal>
    )
}

export default ContactModal